module.exports = {
  admin: require('./admin')
  apcsp: require('./apcsp')
  analyticsLogEvents: require('./analytics-log-events')
  campaigns: require('./campaigns')
  clas: require('./clas')
  classrooms: require('./classrooms')
  contact: require('./contact')
  courses: require('./courses')
  courseInstances: require('./course-instances')
  files: require('./files')
  levels: require('./levels')
  levelSessions: require('./level-sessions')
  markdown: require('./markdown')
  prepaids: require('./prepaids')
  skippedContacts: require('./skipped-contacts')
  thangTypes: require('./thang-types')
  trialRequests: require('./trial-requests')
  userCodeProblems: require('./user-code-problems')
  users: require('./users')
  apiClients: require('./api-clients')
  oauth: require('./o-auth')
}



// WEBPACK FOOTER //
// ./app/core/api/index.coffee